module.exports = __webpack_public_path__ + "static/img/rrrr_14.ffd534a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/rrrr_14.png
// module id = lOaG
// module chunks = 1